var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGreenTick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.875,
    y: 1.875,
    width: 56.25,
    height: 56.25,
    rx: 28.125,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4585 0 0 13.4573 0 30C0 46.5427 13.4585 60 30 60C46.5415 60 60 46.5427 60 30C60 13.4573 46.5415 0 30 0ZM46.725 19.995L28.2635 40.7642C27.8088 41.2754 27.1754 41.5385 26.5373 41.5385C26.0308 41.5385 25.5219 41.3723 25.0962 41.0331L13.5577 31.8023C12.5631 31.0073 12.4015 29.5546 13.1977 28.5588C13.9927 27.5631 15.4465 27.4015 16.4412 28.1977L26.2685 36.0588L43.275 16.9269C44.1196 15.9738 45.5804 15.8885 46.5323 16.7354C47.4854 17.5835 47.5719 19.0419 46.725 19.995Z",
    fill: "#30AF38"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreenTick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/green-tick.93674fb3.svg";
export { ForwardRef as ReactComponent };